import { render, staticRenderFns } from "./ListaDinamicos.vue?vue&type=template&id=8957f4d8&scoped=true"
import script from "./ListaDinamicos.vue?vue&type=script&lang=js"
export * from "./ListaDinamicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8957f4d8",
  null
  
)

export default component.exports